/**
 * Directive: numeric
 */
angular.module('acme.common.directive.numeric', ['acme.common.service.helpers']).directive('numeric', [
  'HelpersService',
  function (HelpersService) {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope: {
        allowNegatives: '<',
      },
      link: function (scope, element, attrs, modelCtrl) {
        var numeric = HelpersService.coerceBooleanProperty(attrs.numeric);
        var allowNegatives = HelpersService.coerceBooleanProperty(attrs.allowNegatives);

        if (numeric) {
          modelCtrl.$parsers.unshift(function (viewValue) {
            var transformedValue = viewValue;
            // this next if is necessary for when using ng-required on your input.
            // In such cases, when a letter is typed first, this parser will be called
            // again, and the 2nd time, the value will be undefined
            if (viewValue === 'undefined') {
              return '';
            }

            if (typeof viewValue === 'string') {
              transformedValue = allowNegatives
                ? viewValue.replace(/[^0-9.-]/g, '')
                : viewValue.replace(/[^0-9.]/g, '');
            }

            transformedValue = parseFloat(transformedValue);

            return !isNaN(transformedValue) ? '' + transformedValue : '';
          });
        }
      },
    };
  },
]);
